// extracted by mini-css-extract-plugin
export default {"muiButton":"MUIButton_muiButton__Eb323","rounded":"MUIButton_rounded__3VLj4","sharp":"MUIButton_sharp__Rvl2i","rounded-xs":"MUIButton_rounded-xs__LGEO-"};